module.exports = __webpack_public_path__ + "img/empty.845eab1f.svg";